import type { MouseEventHandler } from 'react';

import { useDropdownContext } from '~/components/Dropdown/hooks/useDropdownContext';

export const useTriggerEventHandlers = (
  disabled = false,
  onClose?: () => void,
) => {
  const { setIsOpen, collection, selected, isOpen } = useDropdownContext();
  const onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (disabled) {
      return;
    }

    switch (e.code) {
      case 'Escape':
        setIsOpen(false);
        break;
      case 'ArrowDown':
        setIsOpen(true);
        setTimeout(() => collection[0].ref?.current?.focus());
        break;
      case 'ArrowUp':
        setIsOpen(true);
        setTimeout(() =>
          collection[collection.length - 1].ref?.current?.focus(),
        );
        break;
      case 'Enter':
        setIsOpen(true);

        if (selected.length === 1) {
          setTimeout(() => selected[0].ref?.current?.focus());
        }

        break;
      default:
        break;
    }
  };

  const onClick: MouseEventHandler = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) {
      return;
    }

    if (isOpen) {
      onClose?.();
    }

    setIsOpen((prev) => !prev);

    if (selected.length === 1) {
      setTimeout(() => selected[0].ref?.current?.focus());
    }
  };

  return {
    onClick,
    onKeyDown,
  };
};
